import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';

export const ProductViewActions = createActionGroup({
  source: 'Product view actions',
  events: {
    change_ui_product_sidebar_opened: props<{ opened: boolean }>(),
    change_ui_product_sidebar_right_opened: props<{ opened: boolean }>(),
    open_hoodline: props<{ id: string; closeOthers: boolean }>(),
    close_hoodline: props<{ id: string }>(),
    toggle_hoodline: props<{ id: string; closeOthers: boolean }>(),
    change_hood_settings_opened: props<{ opened: boolean }>(),
    enable_multi_edit: emptyProps(),
    disable_multi_edit: emptyProps(),
    toggle_multi_edit: emptyProps(),
    multi_edit_entity_selection_changed: props<{ selected: boolean; entityId: string | string[] }>(),
    multi_edit_entity_type_selected: props<{ typeKey: string }>(),
    multi_edit_entity_property_changed: props<{ projectId: string; propertyChange: EntityEditorPropertyChangedEvent }>(),
    select_multi_edit_entity: props<{ entityId: string; typeKey: string }>(),
    set_multi_entity_hood_ids: props<{ hoodIds: string[] }>(),
    set_overlapping_line_ids: props<{ lineIds: string[] }>()
  }
});
